<template>
    <div class="vue-outer-wrap errorpage">
        <div class="body-wrap-sibling-to-footer">
            <main class="main" id="main" role="main">
                <div class="container mt2">
                    <div class="row">
                        <div class="col-12 col-md-6">
                            <div class="title-button-wrap">
                                <h1 class="h3 orange-text">Hmm... Something went wrong</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    </div>
</template>

<script>
export default {
  name: 'ErrorPage',
  metaInfo: {
    title: "VTOutages Page Not Found",
    meta: [
      {
        name: "description",
        content:
          "VTOutages is Vermont's official outage resource."
      }
    ]
  },
  components: {

  },
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>

</style>
